module.exports = __webpack_public_path__ + "static/img/case-yinhang.571ad974.png";